import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import RootReducer from "./reducers";

const migrations = {
  0: (state) => ({ ...state }),
  1: (state) => ({
    ...state,
    app: {
      ...state?.app,
      notification: state?.app?.notification || {
        tone: null,
        message: null,
      },
    },
  }),
  2: (state) => ({
    ...state,
    auth: {
      ...state?.auth,
      user: {
        ...state?.auth?.user,
        videoInfrastructure: state?.auth?.user?.videoInfrastructure || null,
      },
    },
  }),
  3: (state) => ({
    ...state,
    site: {
      ...state?.sites,
      selectedSite: {
        ...state?.sites?.selectedSite,
        incomeTypes: state?.auth?.selectedSite?.incomeTypes || {},
      },
    },
  }),
};

const persistConfig = {
  key: "root",
  storage,
  version: 3,
  migrate: createMigrate(migrations, { debug: true }),
};

const persistedReducer = persistReducer(persistConfig, RootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunk),
});

const persistor = persistStore(store);

export default { store, persistor };
